import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class B2BEmpresaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let assEmpresaTipoPedido = model;

        if (!assEmpresaTipoPedido.idEmpresa) {
            refs.empresaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-empresa', true))
        }
        if (!assEmpresaTipoPedido.idTipoPedido) {
            refs.tipoPedidoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-necessario-tipo-pedido', true))
        }

        return validated;
    }

}